import { api, queryClient } from "@/core/api-client";
import { isAuthenticatedMe, type Me } from "./guards";

export type { Me, MeAnonymous, MeResponse } from "./guards";
export { isAuthenticatedMe, isAnonymousMe } from "./guards";

/**
 * Сессия виджета. В отличие от web-admin, отсутствие пользователя здесь —
 * не повод никуда уходить: гость работает анонимом, экрана входа нет.
 */
export function useMe() {
  const query = api.useQuery("get", "/me");
  const me = isAuthenticatedMe(query.data) ? query.data : undefined;
  return {
    me,
    isAnonymous: query.data?.type === "anonymous",
    isAuthenticated: me !== undefined,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
  };
}

/**
 * POST /session/restoplace отвечает объектом Me — праймим кэш без второго
 * запроса. Ключ БЕЗ init: [method, path] из ДВУХ элементов
 * (openapi-react-query@0.5.4); useMe зовёт useQuery("get","/me") без init,
 * ключи совпадают.
 */
export function primeMe(me: Me): void {
  queryClient.setQueryData(["get", "/me"], me);
}

export function useRestoplaceLogin() {
  return api.useMutation("post", "/session/restoplace", {
    onSuccess: (me) => {
      if (!isAuthenticatedMe(me)) return;
      // Порядок важен: сперва гасим кэш ПРЕДЫДУЩЕГО пользователя, кроме
      // самого /me, потом праймим. Обратный порядок стирал бы то, что
      // только что положили — активный обсервер useMe перезапросил бы.
      //
      // Именно removeQueries, а не invalidateQueries: инвалидация помечает
      // запись протухшей, но ДАННЫЕ оставляет, и следующий подписчик получит
      // их из кэша до ответа сервера. Смена пользователя в живой вкладке —
      // штатный сценарий (SDK шлёт новый AUTH_CODE_TRANSFER), и данные
      // предыдущего мелькнули бы у следующего.
      queryClient.removeQueries({
        predicate: (q) => q.queryKey[1] !== "/me",
      });
      primeMe(me);
    },
  });
}
